export const PAYERS = Object.freeze({
  INDIVIDUAL: 'individual',
  COMPANY: 'company',
});
